<h4 translate>{{ data.title }}</h4>

<mat-dialog-content>
  <p *ngIf="data.subtitle">
    <strong>{{ data.subtitle | translate }}</strong>
  </p>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z1" multiTemplateDataRows>
    <ng-container *ngFor="let col of data.columns" [matColumnDef]="col.key">
      <th mat-header-cell *matHeaderCellDef>
        {{ col.label | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element[col.key] }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [length]="totalItems"
    [pageSize]="pageSize"
    [pageSizeOptions]="[30, 60, 100, 200]"
    showFirstLastButtons
  >
  </mat-paginator>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    {{ "button-close" | translate }}
  </button>
</mat-dialog-actions>